import blog1 from "@assets/images/meeting-with-client-for-gathering-requirements.avif";
import blog2 from "@assets/images/brainstorming-the-best-software-solutions.avif";
import blog3 from "@assets/images/website-designers-discussing-low-fidelity-mockups.avif";
import blog4 from "@assets/images/coding-on-a-computer.avif";
import blog5 from "@assets/images/software-testing.avif"; 

export const process = [ 
  {
    title: " Requirements Gathering & Ideation",
    image: blog1,
    description:
      "Every project begins with deep IoT development consulting to align your business goals with technical feasibility. We work closely with you to define the user journey, identify key IoT capabilities, and establish a clear roadmap for your MVP.",
  },
  {
    title: "Hardware Selection & System Design",
    image: blog2,
    description:
      "We identify the most cost-effective PCB and microcontroller options for your specific use-case. During this stage, we design the system architecture to handle I/O signals and power management, ensuring the hardware foundation is rock-solid",
  },
  {
    title: "Firmware & Application Development ",
    image: blog3,
    description:
      "Our engineers simultaneously develop the low-level firmware and the high-level IoT app development solutions. By using microservices and cloud computing, we create a modular system where hardware and software communicate with minimal latency.",
  },
  {
    title: "Testing & Validation ",
    image: blog4,
    description:
      "We subject your IoT devices to rigorous real-world testing, simulating various network conditions and environmental stresses. This phase ensures that your monitoring solutions are reliable, secure, and ready for end-users.",
  },
  {
    title: "Deployment & Maintenance",
    image: blog5,
    description:
      "Once validated, we manage the rollout to your production environment and provide ongoing scalable device management. We offer continuous support to handle cloud services for managing IoT data and ensure your firmware stays updated against emerging threats.",
  },
 
]; 